import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CausesServiceApi from "apis/CausesServiceApi";
import { setAllCauses } from "./causes.slice";


export const fetchAllCauses = createAsyncThunk(
    "causes/fetchAll",
    async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await CausesServiceApi.retrieveAllCauses();
      dispatch(setAllCauses(response));
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(err.response?.data?.error || "Failed to fetch causes");
    }
  }
);